import React from 'react';
import CreateUserLayout from "../components/administration/CreateUserLayout";

function CreateUserPage() {

    return <CreateUserLayout />;
}

export default CreateUserPage;
